import React, { useState, useEffect } from "react";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { swapState } from "../../../context/swapState";

const PercentInput = ({
  // Perval,
  bal,
  inputVal,
}: // perc,
{
  // Perval: any;
  bal: string;
  inputVal: any;
  // perc: boolean;
}) => {
  const [percent, setPercent] = useState(0);
  const setSwapState = useSetRecoilState(swapState);
  const swapData = useRecoilValue(swapState);
  useEffect(() => {
    if (!bal) return;
    if (percent !== 0) {
      setSwapState({
        ...swapData,
        input1: ((percent * Number(bal)) / 100).toFixed(2),
      });
    }
  }, [percent, bal]);

  // useEffect(() => {
  //   setPercent(0);
  // }, [perc]);
  const percentChangeHandler = (val: string) => {
    setPercent(Number(val));
    inputVal(val as string);
  };

  return (
    <div className="percent-input-container numeric-font">
      <div
        onClick={() => percentChangeHandler("25")}
        className={`percent-input ${
          percent === 25 ? "percent-input__active" : ""
        }`}
      >
        25%
      </div>
      <div
        onClick={() => percentChangeHandler("50")}
        className={`percent-input ${
          percent === 50 ? "percent-input__active" : ""
        }`}
      >
        50%
      </div>
      <div
        onClick={() => percentChangeHandler("75")}
        className={`percent-input ${
          percent === 75 ? "percent-input__active" : ""
        }`}
      >
        75%
      </div>
      <div
        onClick={() => percentChangeHandler("100")}
        className={`percent-input ${
          percent === 100 ? "percent-input__active" : ""
        }`}
      >
        100%
      </div>
    </div>
  );
};

export default PercentInput;
